import { useState } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useTeachers } from '@/hooks/useTeachers';
import { TeacherCard } from './components/TeacherCard';
import { TeacherFilter } from './components/TeacherFilter';
import { Loader } from '@/components/feedback/Loader';

export function TeacherDirectoryPage() {
  const { teachers, loading } = useTeachers();
  const [filter, setFilter] = useState({ search: '', department: '', designation: '', status: 'active' });

  const filteredTeachers = teachers.filter((t) => {
    const matchSearch = filter.search === '' || 
      `${t.firstName} ${t.lastName}`.toLowerCase().includes(filter.search.toLowerCase());
    const matchDept = filter.department === '' || t.department === filter.department;
    const matchDesig = filter.designation === '' || t.designation === filter.designation;
    const matchStatus = filter.status === '' || t.status === filter.status;
    return matchSearch && matchDept && matchDesig && matchStatus;
  });

  return (
    <Box>
      <Box mb={4}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Teacher Directory
        </Typography>
        <Typography color="text.secondary">
          Browse contact information and profiles of teaching staff
        </Typography>
      </Box>

      <TeacherFilter 
        filter={filter} 
        onFilterChange={setFilter} 
        onReset={() => setFilter({ search: '', department: '', designation: '', status: 'active' })} 
      />

      {loading ? (
        <Loader />
      ) : (
        <Grid container spacing={3}>
          {filteredTeachers.map((teacher) => (
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={teacher.id}>
              <TeacherCard teacher={teacher} basePath="/teachers" />
            </Grid>
          ))}
          {filteredTeachers.length === 0 && (
            <Grid size={{ xs: 12 }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
                <Typography color="text.secondary">No teachers found matching your filters.</Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      )}
    </Box>
  );
}
